import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ParamAlertService } from 'src/app/services/param-alert/param-alert.service';

@Component({
  selector: 'app-param-alert',
  templateUrl: './param-alert.component.html',
  styleUrls: ['./param-alert.component.scss']
})
export class ParamAlertComponent implements OnInit {


  param_alert:string = "";
  sub!: Subscription;
  constructor(
    private paramAlertService:ParamAlertService
  ) { }

  ngOnInit(): void {
    this.sub = this.paramAlertService.data$.subscribe(param => {
      this.param_alert = param;
    })
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  } 

}
